import React, { useRef } from "react";
import "./App.css";
import NavBar from "./components/NavBar";
import AboutPage from "./pages/AboutPage";
import HomePage from "./pages/Home";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Footer from "./components/Footer";
import Form from "./components/Form";
import EndowmentPlans from "./pages/EndowmentPlans";
import SavingsBankAccount from "./pages/SavingsBankAccount";
import FixedDeposit from "./pages/FixedDeposit";
import TaxPlanning from "./pages/TaxPlanning";
import RecurringDeposit from "./pages/RecurringDeposit";
import PublicProvidentFund from "./pages/PublicProvidentFund";
import HealthInsurance from "./pages/HealthInsurance";
import HomeInsurance from "./pages/HomeInsurance";
import MotorInsurance from "./pages/MotorInsurance";
import InsuranceGuidance from "./pages/InsuranceGuidance";
import TravelInsurance from "./pages/TravelInsurance";
import BusinessInsurance from "./pages/BusinessInsurance";
import ForAssociates from "./pages/ForAssociates";
import AtalPensionYojana from "./pages/AtalPensionYojana";
import { NationalSavingsCertificate } from "./pages/NationalSavingsCertificate";
import { UnitLinkedInsurancePlans } from "./pages/UnitLinkedInsurancePlans";
import SecuritiesTransactionTax from "./pages/SecuritiesTransactionTax";
import CustomsDuty from "./pages/CustomsDuty";
import PropertyTax from "./pages/PropertyTax";
import ProfessionalTax from "./pages/ProfessionalTax";
import CapitalGainsTax from "./pages/CapitalGainsTax";
import GST from "./pages/GST";
import IncomeTax from "./pages/IncomeTax";
import LifeInsurance from "./pages/LifeInsurance";
import PersonalAccidentalInsurance from "./pages/PersonalAccidentalInsurance";
import Advisors from "./pages/Advisors";
import Carrers from "./pages/Carrers";
import Contact from "./pages/Contact";
import ScrollToTop from "./components/ScrollToTop";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Blog from "./pages/Blog/Blog";
import TermInsurance from "./pages/TermInsurance";
import WealthiesShield from "./pages/WealthiesShield";
import FindAdvisors from "./pages/FindAdvisors";
import RefundPolicy from "./pages/RefundPolicy";
import TermsAndConditions from "./pages/TermsAndCondition";
import LifeInsuranceIn2026 from "./pages/Blog/LifeInsuranceIn2026";
import InvestmentStrategies from "./pages/Blog/InvestmentStrategies";
import TermInsuranceBlog from "./pages/Blog/TermInsuranceBlog";
import Disclaimer from "./pages/Disclaimer";
import OurTeam from "./pages/OurTeam";
import AwarenessInitiativeBlog from "./pages/Blog/AwarenessInitiativeBlog";

function App() {
  const modalRef = useRef(null);

  const openModal = () => {
    const modal = new window.bootstrap.Modal(modalRef.current);
    modal.show();
  };

  const closeModal = () => {
    if (window.bootstrap && window.bootstrap.Modal) {
      const modalEl = modalRef.current;
      if (modalEl) {
        const modalInstance = window.bootstrap.Modal.getInstance(modalEl);
        if (modalInstance) modalInstance.hide();
      }
    }
  };

  return (
    <div className="App">
      <NavBar />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage openModal={openModal} />} />
          <Route
            path="/about-us"
            element={<AboutPage openModal={openModal} />}
          />
          <Route path="/about" element={<AboutPage openModal={openModal} />} />
          <Route
            path="/contact-us"
            element={<Contact openModal={openModal} />}
          />
          <Route
            path="/for-associates"
            element={<ForAssociates openModal={openModal} />}
          />
          <Route path="/carrers" element={<Carrers openModal={openModal} />} />
          <Route
            path="/disclaimer"
            element={<Disclaimer openModal={openModal} />}
          />
          <Route
            path="/endowment-plans"
            element={<EndowmentPlans openModal={openModal} />}
          />
          <Route
            path="/savings-bank-account"
            element={<SavingsBankAccount openModal={openModal} />}
          />
          <Route
            path="/fixed-deposit"
            element={<FixedDeposit openModal={openModal} />}
          />
          <Route
            path="/recurring-deposit"
            element={<RecurringDeposit openModal={openModal} />}
          />
          <Route
            path="/public-provident-fund"
            element={<PublicProvidentFund openModal={openModal} />}
          />
          <Route
            path="/tax-planning"
            element={<TaxPlanning openModal={openModal} />}
          />
          <Route
            path="/insurance-guides"
            element={<InsuranceGuidance openModal={openModal} />}
          />
          <Route
            path="/life-insurance"
            element={<LifeInsurance openModal={openModal} />}
          />
          <Route
            path="/life-insurance-guide"
            element={<LifeInsurance openModal={openModal} />}
          />
          <Route
            path="/motor-insurance"
            element={<MotorInsurance openModal={openModal} />}
          />
          <Route
            path="/motor-insurance-guide"
            element={<MotorInsurance openModal={openModal} />}
          />
          <Route
            path="/health-insurance"
            element={<HealthInsurance openModal={openModal} />}
          />
          <Route
            path="/home-insurance"
            element={<HomeInsurance openModal={openModal} />}
          />
          <Route
            path="/personal-accidental-insurance"
            element={<PersonalAccidentalInsurance openModal={openModal} />}
          />
          <Route
            path="/travel-insurance"
            element={<TravelInsurance openModal={openModal} />}
          />
          <Route
            path="/business-insurance"
            element={<BusinessInsurance openModal={openModal} />}
          />
          <Route
            path="/income-tax"
            element={<IncomeTax openModal={openModal} />}
          />
          <Route path="/gst" element={<GST openModal={openModal} />} />
          <Route
            path="/capital-gains-tax"
            element={<CapitalGainsTax openModal={openModal} />}
          />
          <Route
            path="/professional-tax"
            element={<ProfessionalTax openModal={openModal} />}
          />
          <Route
            path="/property-tax"
            element={<PropertyTax openModal={openModal} />}
          />
          <Route
            path="/customs-duty"
            element={<CustomsDuty openModal={openModal} />}
          />
          <Route
            path="/securities-transaction-tax"
            element={<SecuritiesTransactionTax openModal={openModal} />}
          />
          <Route
            path="/atal-pension-yojana"
            element={<AtalPensionYojana openModal={openModal} />}
          />
          <Route
            path="/national-savings-certificate"
            element={<NationalSavingsCertificate openModal={openModal} />}
          />
          <Route
            path="/unit-linked-insurance-plans"
            element={<UnitLinkedInsurancePlans openModal={openModal} />}
          />
          <Route
            path="/privacy-policy"
            element={<PrivacyPolicy openModal={openModal} />}
          />
          <Route path="/blog" element={<Blog openModal={openModal} />} />
          <Route
            path="/term-insurance"
            element={<TermInsurance openModal={openModal} />}
          />
          <Route
            path="/wealthies-shield"
            element={<WealthiesShield openModal={openModal} />}
          />
          <Route
            path="/for-advisors"
            element={<Advisors openModal={openModal} />}
          />
          <Route
            path="/advisors"
            element={<FindAdvisors openModal={openModal} />}
          />
          <Route
            path="/refund-policy"
            element={<RefundPolicy openModal={openModal} />}
          />
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions openModal={openModal} />}
          />
          <Route path="/our-team" element={<OurTeam openModal={openModal} />} />

          {/* Blog pages */}
          <Route
            path="/blog/life-insurance-in-2026"
            element={<LifeInsuranceIn2026 />}
          />
          <Route
            path="/blog/investment-strategies-for-beginners"
            element={<InvestmentStrategies />}
          />
          <Route
            path="/blog/why-term-insurance-is-a-must-have"
            element={<TermInsuranceBlog />}
          />
          <Route
            path="/blog/small-steps-big-dreams"
            element={<AwarenessInitiativeBlog />}
          />
        </Routes>
      </BrowserRouter>

      <div
        className="modal fade"
        tabIndex="-1"
        ref={modalRef}
        id="formModal"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content p-4">
            <div className="modal-header border-0">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              ></button>
            </div>
            <div className="modal-body">
              <Form />
            </div>
          </div>
        </div>
      </div>

      <ScrollToTop />
      <Footer />
    </div>
  );
}

export default App;
